import { ServiceAppCode } from "src/api/partnerLogin/partnerlist-type";

const SERVICE_APP_BASEURL: Record<ServiceAppCode, string | undefined> = {
  TAAP: process.env.REACT_APP_SPACE_COURT_BASEURL,
  IFC: process.env.REACT_APP_SPACE_IFC_BASEURL,
  STPM: process.env.REACT_APP_SPACE_STPM_BASEURL,
};

export const getServiceAppBaseUrl = (serviceApp: ServiceAppCode): string => SERVICE_APP_BASEURL[serviceApp] ?? "";

export const buildVisitorSelfRegistUrl = (partnerCode: string, serviceApp: ServiceAppCode): string =>
  `${getServiceAppBaseUrl(serviceApp)}/front/space/partner/${partnerCode}/visitor/selfRegist/form`;
